export { default } from "./Price";
